import { FC, useCallback } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { trackEvent } from 'dibs-tracking';
import classnames from 'classnames';

import { PageLayout } from 'dibs-elements/exports/PageLayout';
import { Link } from 'dibs-elements/exports/Link';
import Checkmark from 'dibs-icons/exports/legacy/Checkmark';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { useBuyerIncentivesMessages } from 'dibs-buyer-incentives/exports/useBuyerIncentivesMessages';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext';

import dibsCss from 'dibs-css';
import styles from './PdpSharedBuyerIncentivesModule.scss';

export const PdpSharedBuyerIncentivesModule: FC = () => {
    const { isMobile } = useServerVarsContext();
    const buyerIncentives = useBuyerIncentivesMessages({ useAll: true });

    const learnMoreClick = useCallback(() => {
        if (isMobile) {
            trackEvent({
                action: 'banner clicked',
                label: 'Buyer Guarantee - PDP',
                category: 'promo interaction',
                value: 0,
            });
        } else {
            trackEvent({
                action: 'buyer protection',
                label: 'clicked',
                category: 'product',
                value: 0,
            });
        }
    }, [isMobile]);

    return (
        <PageLayout setViewportBackground="sassyColorBuyerTertiary" setOffset={false}>
            <div
                className={classnames(styles.container, {
                    [dibsCss.pyMedium]: isMobile,
                    [dibsCss.pyLarge]: !isMobile,
                    [dibsCss.textCenter]: !isMobile,
                })}
            >
                <HeadingLevel>
                    {Heading => (
                        <Heading
                            className={classnames(
                                dibsCss.sassyFontHeaderLarge,
                                dibsCss.mbXsmall,
                                dibsCss.mt0
                            )}
                        >
                            <FormattedMessage
                                id="PdpSharedBuyerIncentivesModule.title"
                                defaultMessage="The 1stDibs Promise"
                            />
                        </Heading>
                    )}
                </HeadingLevel>
                <Link
                    href="/about/promise/"
                    onClick={learnMoreClick}
                    target="_blank"
                    className={classnames(
                        styles.learnMore,
                        dibsCss.sassyFontBody,
                        dibsCss.inlineBlock
                    )}
                >
                    {isMobile ? (
                        <FormattedMessage
                            id="PdpSharedBuyerIncentivesModule.learnMoreMobile"
                            defaultMessage="Learn more"
                        />
                    ) : (
                        <FormattedMessage
                            id="PdpSharedBuyerIncentivesModule.learnMore"
                            defaultMessage="Learn More"
                        />
                    )}
                </Link>
                <div
                    className={classnames(styles.incentivesWrapper, dibsCss.grid, {
                        [dibsCss.sassyFontHeaderMedium]: isMobile,
                        [dibsCss.gapSmall]: isMobile,

                        [dibsCss.sassyFontHeaderSmall]: !isMobile,
                        [dibsCss.gapYMedium]: !isMobile,
                        [dibsCss.gapXXxlarge]: !isMobile,
                        [dibsCss.mxAuto]: !isMobile,
                    })}
                >
                    {buyerIncentives.map((benefit, index) => (
                        <div
                            key={index}
                            className={classnames(dibsCss.flex, dibsCss.itemsCenter, {
                                [dibsCss.gapSmall]: isMobile,
                                [dibsCss.gapXsmall]: !isMobile,
                            })}
                        >
                            <Checkmark
                                className={classnames(styles.icon, dibsCss.fillBuyerprimary)}
                            />
                            {benefit}
                        </div>
                    ))}
                </div>
            </div>
        </PageLayout>
    );
};
